module.exports = __webpack_public_path__ + "img/us.18c0ef1d.svg";